<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
  </div>
</template>

<script>
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import Qs from 'qs'
import UPDATE from '@/components/page/update'
import axios from '@/utils/request'

var auth = {
  '1': '按開戶時間初始化所有沉睡客戶數據',
  '2': '按審批時間初始化所有新客戶數據',
  '3': '按成交時間初始化所有A客戶交易時長分類數據'
}

const fieldList = {
  'name': '姓名',
  'mobile_phone': '会员手機',
  'email': '邮箱',
  'account_group': '賬戶組別',
  'payment_gateway_tags': '支付網關標記',
  'pay_verification_mark': '支付驗證標記',
  'account_level_code': '用戶類型',
  'account_status_code': '交易賬戶狀態',
  'recent_login_time': '最後登錄時間',
  'sex': '性別',
  'utm': '媒介',
  'active_date': '激活時間',
  'last_trade_date': '最後交易日',
  'remark': '後台客戶維護標記',
  'first_deposit': '首次存款金額',
  'recent_deposit_time': '最近存款時間',
  'recent_withdrawal_time': '最近取款時間'
}

function getToday() {
  return formatDate(new Date())
}

function getTomorrow() {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return formatDate(tomorrow)
}

function formatDate(date) {
  let year = date.getFullYear()
  let month = (date.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以要加1并确保是两位数
  let day = date.getDate().toString().padStart(2, '0')
  let time = year + '/' + month + '/' + day
  console.info(time)
  return time
}

function getTimestr() {
  return [getToday(), getTomorrow()]
}

export default {
  name: 'customerList',
  components: {
    FORM
  },

  data() {
    return {
      queryData: {},

      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: '========== 按時間範圍更新數據 ================================================================================================================================================================', type: 'info', disable: true},
          {
            title: '時間',
            field: 'time',
            type: 6,
            data: getTimestr(),
            format: 'yyyy/MM/dd',
            startEndParam: ['startTime', 'endTime']
          },
          { click: '===================================================================================================================================', type: 'info', disable: true},

          { title: '需要更新的字段', field: 'fields', type: 2, optionList: fieldList, multiple: true, placeholder: '（可多選）'},
          { click: 'initFiledValue', buttonLabel: '按【開戶時間】更新【字段】' },
          { click: '====================================================================================================================', type: 'info', disable: true},

          { title: '初始化數據選項', field: 'auth', type: 4, optionList: auth,data: [], },
          { click: 'initByTime', buttonLabel: '按【時間】初始化數據', type: 'danger'},
          { click: '============================================', type: 'info', disable: true},

          { click: 'recension', buttonLabel: '按【激活時間】查漏存取款數據' },
          { click: '============================================================================================================================================================', type: 'info', disable: true},


          { click: '========== 按交易賬號更新數據 ================================================================================================================================================================', type: 'info', disable: true},
          { title: '需要更新的賬號', field: 'customerNumbers' },
          { click: 'initByCustomerNumber', buttonLabel: '按【賬號】更新' },


          { click: '========== 無參數更新數據 ====================================================================================================================================================================', type: 'info', disable: true},
          { click: 'schedule', buttonLabel: '執行定時器中的所有任務' },
        ]
      }
    }
  },
  methods: {

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      console.info(clickName , '==>' , data)
      if ('initByTime' == clickName) {
        this.ajax(Url.sleeping.initByTime, data, res => this.msg(res))
      } else if ('initByCustomerNumber' == clickName) {
        this.ajax(Url.sleeping.initByCustomerNumber, data, res => this.msg(res))
      } else if ('recension' == clickName) {
        this.ajax(Url.sleeping.initRecension, data, res => this.msg(res))
      }else if ('schedule' == clickName) {
        this.ajax(Url.sleeping.initSchedule, data, res => this.msg(res))
      }else if ('initFiledValue' == clickName) {
        // console.log("initFieldValue", data);
        this.ajax(Url.sleeping.initFiledValue, data, res => this.msg(res))
      }

    },
    ajax: function(url, data, suc, fail) {
      this.formatDate(data)
      this.$axios.post(url, Qs.stringify(data || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    msg: function(res) {
      this.$message.success(res.result)
    },

    formatDate(data) {
      data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
      data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
    }
  },
  mounted() {
  }
}

</script>

